import {
  Card,
  CardMedia,
  IconButton,
  Skeleton,
  Stack,
  Tooltip,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { API_URL } from "service/root/rootApi";
import { Player } from "service/player/type";
import { useTranslation } from "react-i18next";
import { Close, CloudDownload } from "@mui/icons-material";
import Typography from "common/components/Typography";
import { getScore } from "service/draft";
import { Sheet } from "service/sheet/type";
import { applyBoxPreferences, boxDownloadProps } from "common/utils";

type ComparePlayerCardProps = {
  player?: Player;
  score?: number;
  sheet?: Sheet;
  onDelete: () => void;
  color: "player1" | "player2";
};

const ComparePlayerCard = (props: ComparePlayerCardProps) => {
  const { player, onDelete, color, score, sheet } = props;
  const { t } = useTranslation();

  // Box telle qu'elle sera proposée en draft sur la feuille sélectionnée.
  const sheetBox = applyBoxPreferences(
    player?.characters ?? [],
    player?.preferences?.find((p) => p.sheetId === sheet?.id)?.characters,
  );

  return (
    <Card
      sx={{
        height: 170,
        width: 140,
        bgcolor: ({ palette }) => palette.common[color].paper,
      }}
    >
      <Stack
        direction="column"
        gap={0.5}
        px={1}
        py={0.5}
        justifyContent={player !== undefined ? "space-between" : "center"}
        alignItems="center"
        height="100%"
      >
        {player === undefined ? (
          <>
            <Typography size="sm" textAlign="center">
              {t("Sélectionne un joueur")}
            </Typography>
            <Skeleton
              variant="circular"
              width={60}
              height={60}
              animation={false}
            />
          </>
        ) : (
          <>
            <Stack justifyContent="space-between" direction="row" width="100%">
              <Tooltip
                title={
                  sheet
                    ? t("Télécharger la box pour {{sheet}}", {
                        sheet: sheet.name,
                      })
                    : t("Télécharger")
                }
                arrow
              >
                <IconButton
                  {...boxDownloadProps(player.pseudo, sheetBox, sheet?.name)}
                >
                  <CloudDownload />
                </IconButton>
              </Tooltip>
              <IconButton onClick={onDelete}>
                <Close />
              </IconButton>
            </Stack>
            <Typography
              textAlign="center"
              textOverflow="ellipsis"
              overflow="hidden"
              whiteSpace="nowrap"
              width="8rem"
              size="sm"
              title={player.pseudo}
            >
              {player.pseudo}
            </Typography>
            <CardMedia
              component="img"
              sx={{
                width: "4rem",
              }}
              src={`${API_URL}assets/genshin/characters/${player.avatar}/avatar.png`}
              title={player.pseudo}
            />
            {score ?? "..."}
          </>
        )}
      </Stack>
    </Card>
  );
};

export default ComparePlayerCard;
